import { render } from "./WeekDetail.vue?vue&type=template&id=12719a31&scoped=true&ts=true"
import script from "./WeekDetail.vue?vue&type=script&lang=ts"
export * from "./WeekDetail.vue?vue&type=script&lang=ts"

import "./WeekDetail.vue?vue&type=style&index=0&id=12719a31&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12719a31"]])

export default __exports__